import {
  Alert,
  Fade,
  Slide,
  SlideProps,
  Snackbar,
  Typography,
  Theme,
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import { useEffect, useState } from 'react';

export const SnackBar = ({
  showSnackBar,
  message,
}: {
  showSnackBar: boolean;
  message: string;
}) => {
  const [state, setState] = useState<{
    open: boolean;
    Transition: React.ComponentType<
      TransitionProps & {
        children: React.ReactElement<any, any>;
      }
    >;
  }>({
    open: false,
    Transition: Fade,
  });

  useEffect(() => {
    if (showSnackBar) {
      setState({
        open: showSnackBar,
        Transition: SlideTransition,
      });
    }
  }, [showSnackBar]);

  const SlideTransition = (props: SlideProps) => {
    return <Slide {...props} direction="up" />;
  };

  const handleClose = () => {
    setState({
      ...state,
      open: false,
    });
  };

  return (
    <Snackbar
      open={state.open}
      onClose={handleClose}
      TransitionComponent={state.Transition}
      key={state.Transition.name}
      autoHideDuration={3000}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: '80px !important' }}
    >
      <Alert
        onClose={handleClose}
        severity="success"
        variant="filled"
        sx={(theme: Theme) => ({
          width: '100%',
          backgroundColor: theme.palette.green.main,
          '& .MuiAlert-icon': { display: 'none' },
        })}
      >
        <Typography variant="body1">{message}</Typography>
      </Alert>
    </Snackbar>
  );
};
